import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToolFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.52696 2.65761C9.84214 2.06342 12.4068 2.67186 14.2226 4.48762C16.2557 6.52075 16.7757 9.49151 15.7866 12.0048L20.386 15.8966C21.8599 17.1438 21.9531 19.3845 20.5878 20.7498C19.2225 22.1151 16.9819 22.0219 15.7347 20.5479L11.8439 15.9497C9.32978 16.9408 6.35717 16.4212 4.32307 14.3871C2.50712 12.5711 1.89874 10.0061 2.49325 7.69077C2.69252 6.91467 3.67235 6.66893 4.21455 7.25789L7.25889 10.5648L9.55638 9.72057L10.4026 7.42089L7.09446 4.37938C6.50489 3.83733 6.7505 2.85688 7.52696 2.65761Z"
	})
});
export default SvgToolFill;
